// extracted by mini-css-extract-plugin
export default {"Emoji":"bby_a bia_i bia_q bia_j"};